import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import NumberFormat from "react-number-format";
import ErrorMessage from './ErrorMessage';

const FormattedNumberInput= ({name, placeholder}) => {
  const { control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="form-label-group">
          <NumberFormat
            id={field.name}
            name={field.name}
            onBlur={field.onBlur}
            value={field.value}
            thousandSeparator={true}
            className={`form-control ${isTouched && error ? "is-invalid" : ""}`}
            placeholder={placeholder}
            decimalScale={2}
            onValueChange={(valuesObj) => {
              const {floatValue} = valuesObj;
              field.onChange(floatValue)
            }}
          />
          <label htmlFor={field.name}>{placeholder}</label>
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}

FormattedNumberInput.defaultProps = {};

FormattedNumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default FormattedNumberInput;